<style lang="scss" src='./Main.scss' scoped></style>
<template src="./Main.html"></template>

<script>
  import {
    mapState,
    mapActions,
    mapMutations,
    mapGetters
  } from "vuex";
  import ProductsCarousel from '@/components/productsCarousel/ProductsCarousel'
  import ProductsGrid from '@/components/productsGrid/ProductsGrid'
  import Banner from '@/components/banner/Banner'

  export default {
    name: "Main",
    components: {
      ProductsCarousel,
      ProductsGrid,
      Banner,
    },
    data() {
      return {

      };
    },
    computed: {
      ...mapState("Main", ['loading', 'productList', 'bannerList']),
      ...mapGetters("Main", ['getCarousel', 'getBanner', 'getCurrentStore']),
    },

    methods: {
      ...mapActions('Main', ['fnApiGetStoreList', 'fnApiGetStoreProducts', 'fnApiGetCategorys', 'fnApiGetBanners', 'fnApiGetAvailableCoupons']),
    },

    beforeCreate() {},

    created() {
      window.fbq('track', 'PageView');
    },

    async mounted() {
      await this.fnApiGetStoreList();
      let currentId = this.getCurrentStore
      this.fnApiGetCategorys();
      this.fnApiGetStoreProducts();
      this.fnApiGetBanners();
      this.fnApiGetAvailableCoupons();
    },

    beforeDestroy() {

    },
  };

</script>
